import { useEffect } from 'react'
import { getQueryOptions } from '~/services'
import { createFileRoute } from '@tanstack/react-router'
import { WebchatOnboarding } from '~/features/bots/components'
import { useSetWorkspacePreferences } from '~/hooks'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/new-chat')({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      getQueryOptions('workspaces_/$workspaceId_/preferences/$path', {
        path: 'onBoardingCompleted',
        workspaceId: params.workspaceId,
        params: { botId: params.botId }, // to satisfy the type but not used in the key
      })
    ),
})

function RouteComponent() {
  const { workspaceId, botId } = Route.useParams()
  const onboardingCompleted = Route.useLoaderData()
  const { mutate: setWorkspacePreference } = useSetWorkspacePreferences(workspaceId)

  useEffect(() => {
    if (onboardingCompleted === false) {
      setWorkspacePreference({ path: 'onBoardingCompleted', value: true })
    }
  }, [])

  return <WebchatOnboarding botId={botId} workspaceId={workspaceId} />
}
